import React, { Component } from "react";
import swal from "sweetalert";
import { Button, TextField, Link } from "@material-ui/core";
const axios = require("axios");

export default class Register extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      confirm_password: "",
      email: "",
      phonenumber: "",
      clientId: "",
    };
  }

  onChange = (e) => this.setState({ [e.target.name]: e.target.value });

  register = () => {
    axios
      .post("http://localhost:2000/register", {
        username: this.state.username,
        password: this.state.password,
        email: this.state.email,
        phonenumber: this.state.phonenumber,
        clientId: this.state.clientId,
      })
      .then((res) => {
        swal({
          text: res.data.title,
          icon: "success",
          type: "success",
        });
        this.props.history.push("/");
      })
      .catch((err) => {
        swal({
          text: err.response.data.errorMessage,
          icon: "error",
          type: "error",
        });
      });
  };

  render() {
    return (
      <div style={{ marginTop: "200px" }}>
        <div>
          <h2>Register</h2>
        </div>

        <div>
          <input
            id="standard-basic"
            type="text"
            autoComplete="off"
            name="username"
            value={this.state.username}
            onChange={this.onChange}
            placeholder="User Name"
            required
          />
          <br />
          <br />
          <input
            id="standard-basic"
            type="password"
            autoComplete="off"
            name="password"
            value={this.state.password}
            onChange={this.onChange}
            placeholder="Password"
            required
          />
          <br />
          <br />
          <input
            id="standard-basic"
            type="password"
            autoComplete="off"
            name="confirm_password"
            value={this.state.confirm_password}
            onChange={this.onChange}
            placeholder="Confirm Password"
            required
          />
          <br />
          <br />
          <input
            id="standard-basic"
            type="email"
            autoComplete="off"
            name="email"
            value={this.state.email}
            onChange={this.onChange}
            placeholder="email"
            required
          />
          <br />
          <br />
          <input
            id="standard-basic"
            type="number"
            autoComplete="off"
            name="phonenumber"
            value={this.state.phonenumber}
            onChange={this.onChange}
            placeholder="phonenumber"
            required
          />
          <br />
          <br />
          <input
            id="standard-basic"
            type="number"
            autoComplete="off"
            name="clientId"
            value={this.state.clientId}
            onChange={this.onChange}
            placeholder="clientId"
            required
          />
          <br />
          <br />
          <button
            className="button_style"
            variant="contained"
            color="primary"
            size="small"
            disabled={this.state.username == "" && this.state.password == ""}
            onClick={this.register}
          >
            Register
          </button>{" "}
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <Link href="/">Login</Link>
        </div>
      </div>
    );
  }
}
